export default __webpack_public_path__ + "static/media/_guard.a23cbcd5.jpg";